module.exports = __webpack_public_path__ + "static/media/girl.8fc291ef.jpg";